import { AppDateTimePicker } from "@/common/components/Datetime/AppDateTimePicker";
import { DATETIME_FORMATS } from "@/common/constants/common";
import { FilterValueInputProps } from "@/common/ts/filters";
import { FilterValueType } from "@/core/api/generated/v1";

interface Props extends FilterValueInputProps {}

export default function FilterDateValueInput({ item, textFieldProps, onChange }: Props) {
  if (item.valueType !== FilterValueType.Date) {
    console.error(`Invalid value type '${item.valueType}'.`);
    return null;
  }

  return (
    <AppDateTimePicker
      ampm={false}
      label='Value'
      value={item.valueAsDateAsMoment() || null}
      format={DATETIME_FORMATS.DISPLAY_DATETIME}
      onChange={(newValue) => {
        onChange(newValue);
      }}
      slotProps={{
        textField: {
          ...textFieldProps,
        },
      }}
      // slots={{
      //   textField: (params) => (
      //     <TextField
      //       {...textFieldProps}
      //       {...params}
      //       InputProps={{
      //         ...params.InputProps,
      //         endAdornment: (
      //           <AppIconButton
      //             onClick={(e) => {
      //               e.preventDefault();
      //               e.stopPropagation();
      //               onChange(undefined);
      //             }}
      //           >
      //             <AppIcon of='clear' color='inherit' />
      //           </AppIconButton>
      //         ),
      //       }}
      //     />
      //   ),
      // }}
    />
  );
}
